import { normalizeTableServiceState } from './tableDisplayState';

const TRANSFERABLE_ORDER_STATUSES = new Set(["pending", "preparing", "completed"]);

const getOrderTableId = (order) => order?.table_id ?? order?.tableId ?? null;

const getRequestTableId = (request) =>
  request?.table?.id ?? request?.table_id ?? request?.tableId ?? null;

const isTransferableOrder = (order) => {
  if (!order) {
    return false;
  }

  const paymentStatus = order.payment_status ?? order.paymentStatus ?? null;
  const status = order.status ?? null;

  return paymentStatus !== "paid" && TRANSFERABLE_ORDER_STATUSES.has(status);
};

const isPendingRequest = (request) => request?.status === "pending";

export const getTransferableOrderCountForTable = (allOrders = [], tableId) =>
  allOrders.filter((order) => isTransferableOrder(order) && getOrderTableId(order) === tableId).length;

export const getPendingRequestCountForTable = (requests = [], tableId) =>
  requests.filter((request) => isPendingRequest(request) && getRequestTableId(request) === tableId).length;

export const isTransferSourceEmpty = (allOrders = [], requests = [], tableId) =>
  getTransferableOrderCountForTable(allOrders, tableId) === 0 &&
  getPendingRequestCountForTable(requests, tableId) === 0;

export const getTransferDestinationState = (table, allOrders = [], requests = []) => {
  const tableId = table?.id ?? null;
  const serviceState = normalizeTableServiceState(table?.serviceState ?? table?.status);
  const orderCount = getTransferableOrderCountForTable(allOrders, tableId);
  const requestCount = getPendingRequestCountForTable(requests, tableId);

  if (serviceState === 'reserved') {
    return { disabled: true, occupied: true, label: 'Rezerve', orderCount, requestCount, serviceState };
  }
  if (serviceState !== 'active') {
    return { disabled: true, occupied: true, label: 'Servis Dışı', orderCount, requestCount, serviceState };
  }
  if (orderCount > 0 || requestCount > 0) {
    return { disabled: true, occupied: true, label: 'Meşgul', orderCount, requestCount, serviceState };
  }

  return { disabled: false, occupied: false, label: '', orderCount, requestCount, serviceState };
};

export const isTransferDestinationOccupied = (allOrders = [], requests = [], tableId, table = null) =>
  getTransferDestinationState(table || { id: tableId }, allOrders, requests).disabled;
